import { render, staticRenderFns } from "./PosterControls.vue?vue&type=template&id=a1e8192a&scoped=true&"
import script from "./PosterControls.vue?vue&type=script&lang=js&"
export * from "./PosterControls.vue?vue&type=script&lang=js&"
import style0 from "./PosterControls.vue?vue&type=style&index=0&id=a1e8192a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e8192a",
  null
  
)

export default component.exports